<!--<p-timeline [value]="trackings" styleClass="hide-oposite tracking-timeline">
  <ng-template pTemplate="content" let-event>
    <b>{{getActionDescription(event.action)}}</b><br />
    <small *ngIf="event.message"><i class="pi pi-exclamation-triangle" style="color: #808080"></i>&nbsp;{{event.message}}<br></small>
    <small *ngIf="event.user">{{event.user?.name}}<br></small>
    <small *ngIf="event.channel=='import'">{{'general.tracking_from_import' | translate}}<br></small>
    <small>{{event.date | date:'dd/MM/yy HH:mm':'GMT'}}</small>
  </ng-template>
</p-timeline>-->
<div class="timeline">
  <div class="timeline-event" *ngFor="let event of history_data.values">
    <div class="p-d-flex p-ai-center p-mt-3 p-pt-2" (click)="toogleEvent(event)" style="cursor: pointer;">
      <div class="card-title flex-grow-1">
        <span *ngFor="let column of getColumns('header')" class="p-mr-2">{{getValueFor(event, column)}}</span>
        <span *ngIf="event.channel!=null && event.channel=='import'" class="p-mr-2">{{'general.tracking_import' | translate}}</span>
      </div>
      <a>
        <fa-icon *ngIf="event.is_opened" [icon]="['fas', 'chevron-up']"></fa-icon>
        <fa-icon *ngIf="!event.is_opened" [icon]="['fas', 'chevron-down']"></fa-icon>
      </a>
    </div>
    <div class="timeline-event-details p-d-flex p-flex-column" *ngIf="event.is_opened">
      <div *ngFor="let column of getColumns('detail')" class="item-data">
        <label>{{column.label}}</label>
        <div class="value" [innerHtml]="getValueFor(event, column)"></div>
      </div>
      <div *ngIf="event.tracking_message!=null && event.tracking_message!=''" class="message">
        <fa-icon [icon]="['fas', 'circle-info']"></fa-icon>&nbsp;{{event.tracking_message}}
      </div>
    </div>
  </div>
</div>
<div *ngIf="history_data.values.length==0">
  {{'general.tracking_empty' | translate }}
</div>
